import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    authorized: 'Authorized',
    blocked: 'Blocked',
    pending: 'Pending',
  },
  fr: {
    authorized: 'Autorisé',
    blocked: 'Bloqué',
    pending: 'En attente',
  },
});

export default locales;
